import * as React from 'react';
import { IconInvoice } from '@tock/icons';
import { consumer } from '@tock/coretypes';
import AdditionalCosts from 'components/AdditionalCosts';
import OfferingDetailsMetadataItem from 'components/business/offering/OfferingDetailsMetadataItem';

interface Props {
  price: consumer.OfferedPriceSummary;
  type: consumer.Offering.Type;
}

const OfferingDetailsAdditionalCosts: React.FunctionComponent<Props> = ({ price, type }) => {
  const renderFees = price.priceDisplayStyle !== 'MIN_REQUIRED_SPEND';

  return renderFees && AdditionalCosts.hasPriceRanges(price) ? (
    <OfferingDetailsMetadataItem icon={IconInvoice} data-testid="add-on-details">
      <AdditionalCosts price={price} />
    </OfferingDetailsMetadataItem>
  ) : null;
};

export default OfferingDetailsAdditionalCosts;
